import React from "react";
import styled from "styled-components";
import tw from "tailwind.macro";
import ClipboardJS from "clipboard"

import "./index.css";
import MinecraftConnectionSimulator from "./components/organism/MinecraftConnectionSimulator";
import ExternalButton from "./components/atom/ExternalButton";

const Container = styled.div`
  height: 100%;
  margin: 0;
  background-color: #F6F6F6;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 2000 1500'%3E%3Cdefs%3E%3CradialGradient id='a' gradientUnits='objectBoundingBox'%3E%3Cstop offset='0' stop-color='%23dcdcdc'/%3E%3Cstop offset='1' stop-color='%23f4f4f4'/%3E%3C/radialGradient%3E%3ClinearGradient id='b' gradientUnits='userSpaceOnUse' x1='0' y1='750' x2='1550' y2='750'%3E%3Cstop offset='0' stop-color='%23e8e8e8'/%3E%3Cstop offset='1' stop-color='%23f4f4f4'/%3E%3C/linearGradient%3E%3Cpath id='s' fill='url(%23b)' d='M1549.2 51.6c-5.4 99.1-20.2 197.6-44.2 293.6c-24.1 96-57.4 189.4-99.3 278.6c-41.9 89.2-92.4 174.1-150.3 253.3c-58 79.2-123.4 152.6-195.1 219c-71.7 66.4-149.6 125.8-232.2 177.2c-82.7 51.4-170.1 94.7-260.7 129.1c-90.6 34.4-184.4 60-279.5 76.3C192.6 1495 96.1 1502 0 1500c96.1-2.1 191.8-13.3 285.4-33.6c93.6-20.2 185-49.5 272.5-87.2c87.6-37.7 171.3-83.8 249.6-137.3c78.4-53.5 151.5-114.5 217.9-181.7c66.5-67.2 126.4-140.7 178.6-218.9c52.3-78.3 96.9-161.4 133-247.9c36.1-86.5 63.8-176.2 82.6-267.6c18.8-91.4 28.6-184.4 29.6-277.4c0.3-27.6 23.2-48.7 50.8-48.4s49.5 21.8 49.2 49.5c0 0.7 0 1.3-0.1 2L1549.2 51.6z'/%3E%3Cg id='g'%3E%3Cuse href='%23s' transform='scale(0.12) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.2) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.25) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(0.3) rotate(-20)'/%3E%3Cuse href='%23s' transform='scale(0.4) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(0.5) rotate(20)'/%3E%3Cuse href='%23s' transform='scale(0.6) rotate(60)'/%3E%3Cuse href='%23s' transform='scale(0.7) rotate(10)'/%3E%3Cuse href='%23s' transform='scale(0.835) rotate(-40)'/%3E%3Cuse href='%23s' transform='scale(0.9) rotate(40)'/%3E%3Cuse href='%23s' transform='scale(1.05) rotate(25)'/%3E%3Cuse href='%23s' transform='scale(1.2) rotate(8)'/%3E%3Cuse href='%23s' transform='scale(1.333) rotate(-60)'/%3E%3Cuse href='%23s' transform='scale(1.45) rotate(-30)'/%3E%3Cuse href='%23s' transform='scale(1.6) rotate(10)'/%3E%3C/g%3E%3C/defs%3E%3Cg %3E%3Cg transform=''%3E%3Ccircle fill='url(%23a)' r='3000'/%3E%3Cg opacity='0.5'%3E%3Ccircle fill='url(%23a)' r='2000'/%3E%3Ccircle fill='url(%23a)' r='1800'/%3E%3Ccircle fill='url(%23a)' r='1700'/%3E%3Ccircle fill='url(%23a)' r='1651'/%3E%3Ccircle fill='url(%23a)' r='1450'/%3E%3Ccircle fill='url(%23a)' r='1250'/%3E%3Ccircle fill='url(%23a)' r='1175'/%3E%3Ccircle fill='url(%23a)' r='900'/%3E%3Ccircle fill='url(%23a)' r='750'/%3E%3Ccircle fill='url(%23a)' r='500'/%3E%3Ccircle fill='url(%23a)' r='380'/%3E%3Ccircle fill='url(%23a)' r='250'/%3E%3C/g%3E%3Cg transform='rotate(-90 0 0)'%3E%3Cuse href='%23g' transform='rotate(10)'/%3E%3Cuse href='%23g' transform='rotate(120)'/%3E%3Cuse href='%23g' transform='rotate(240)'/%3E%3C/g%3E%3Ccircle fill-opacity='0.56' fill='url(%23a)' r='3000'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  background-size: cover;
  background-attachment: fixed;
`;

const Header = styled.div`
  ${tw`flex justify-start pl-6 pt-4 sm:pl-12 sm:pt-8`}
`;

const ClickableLogo = styled.a`
  ${tw``}
`;

const Logo = styled.img`
  ${tw`w-48`}
`;

const SubTitle = styled.h2`
  ${tw`w-3/4 m-auto font-semibold text-xl uppercase tracking-wide text-craftasiaBlack mt-10 mb-6 text-center`}
`;

const Text = styled.p`
  ${tw`font-light w-2/3 text-center m-auto`}
`;

const Instruction = styled.div`
  ${tw`flex justify-center mt-3 mb-3 w-5/6 ml-auto mr-auto`}
`

const TextInstruction = styled.p`
  ${tw`font-normal text-lg text-craftasiaBlack`}
`;

const IconInstruction = styled.p`
  ${tw`font-medium text-normal text-white bg-craftasiaBlack rounded-full h-6 w-6 flex items-center justify-center mr-2 min-w-6`}
`

const LinkedInstruction = styled.a`
  ${tw`font-bold text-craftasiaBrown hover:underline`}
`;

const ImportantInstruction = styled.span`
  ${tw`font-bold`}
`

const ClickableIP = styled.button`
  ${tw`font-medium bg-craftasiaOrange-300 text-white tracking-wide pl-2 pr-2 rounded-lg shadow-lg cursor-pointer hover:bg-craftasiaOrange-400 hover:shadow-xs`}
  transition: 0.1s;
`

const ClickableInstruction = styled.span`
  ${tw`font-light italic text-sm`}
`;

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      clickableInstruction: `(clique pour copier)`
    };
  }

  componentDidMount() {
    new ClipboardJS('.clickableIPButton');
    new ClipboardJS('.clickableIPMinecraft');
  }

  _IPCopied = () => {
    this.setState({
      clickableInstruction: `(IP copiée ✅)`
    });

    setTimeout(() => {
      this.setState({
        clickableInstruction: `(clique pour copier)`
      });
    }, 2500);
  }



  render() {
    return (
      <Container className="font-body">
        <Header>
          <ClickableLogo href="https://craftasia.fr/inscription" target="_blank">
            <Logo src="https://craftasia.fr/themes/craftasia.fr/assets/images/ressources/icon/complet/logo-comp-transparent.png" alt="Logo Craftasia" />
          </ClickableLogo>
        </Header>

        <SubTitle>Plus de 47000 joueurs ! <span role="img" aria-label="emoji fêstif">🥳</span></SubTitle>
        <Text>
          Craftasia est un serveur Minecraft gratuit multi-modes comprenant : mini-jeux, freebuild, semi-rp ainsi que des quêtes, des succès et des donjons. Vous pourrez y retrouver tous vos amis !
        </Text>

        <SubTitle>Comment jouer et construire sur Craftasia ? <span role="img" aria-label="emoji maison">🏡</span></SubTitle>
        <Instruction>
          <IconInstruction>1</IconInstruction>
          <TextInstruction>Ouvre le jeu{" "}
            <LinkedInstruction href="https://www.minecraft.net/fr-fr/" target="_blank">
              Minecraft
              <svg className="inline-block h-4 w-4 text-craftasiaBrown" fill="currentColor" viewBox="0 0 20 20">
                <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path>
                <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path>
              </svg>
            </LinkedInstruction>
          </TextInstruction>
        </Instruction>
        <Instruction>
          <IconInstruction>2</IconInstruction>
          <TextInstruction>Clique sur le bouton <ImportantInstruction>Multijoueur</ImportantInstruction> puis sur <ImportantInstruction>Nouveau serveur</ImportantInstruction></TextInstruction>
        </Instruction>
        <Instruction>
          <IconInstruction>3</IconInstruction>
          <TextInstruction>Colle l'
            <ImportantInstruction>IP </ImportantInstruction>
            <ClickableIP className="clickableIPButton" data-clipboard-text="craftasia.fr" onClick={this._IPCopied}>
              craftasia.fr{" "}
              <ClickableInstruction>{this.state.clickableInstruction}</ClickableInstruction>
            </ClickableIP>
            {" "}dans{" "}
            <ImportantInstruction>Adresse du serveur</ImportantInstruction>
          </TextInstruction>
        </Instruction>
        <div className="clickableIPMinecraft" data-clipboard-text="craftasia.fr" onClick={this._IPCopied}>
          <MinecraftConnectionSimulator />
        </div>
        <Instruction>
          <IconInstruction>4</IconInstruction>
          <TextInstruction>Clique sur <ImportantInstruction>Valider</ImportantInstruction> pour te connecter sur Craftasia !</TextInstruction>
        </Instruction>
        <Instruction>
          <IconInstruction>5</IconInstruction>
          <TextInstruction>
            <LinkedInstruction href="https://craftasia.fr/inscription" target="_blank">
              Inscris-toi
              <svg className="inline-block h-4 w-4 text-craftasiaBrown" fill="currentColor" viewBox="0 0 20 20">
                <path d="M11 3a1 1 0 100 2h2.586l-6.293 6.293a1 1 0 101.414 1.414L15 6.414V9a1 1 0 102 0V4a1 1 0 00-1-1h-5z"></path>
                <path d="M5 5a2 2 0 00-2 2v8a2 2 0 002 2h8a2 2 0 002-2v-3a1 1 0 10-2 0v3H5V7h3a1 1 0 000-2H5z"></path>
              </svg>
            </LinkedInstruction>
            {" "}sur le site <ImportantInstruction>en étant connecté</ImportantInstruction> à Minecraft pour <ImportantInstruction>sauvegarder</ImportantInstruction> ton compte.</TextInstruction>
        </Instruction>

        <ExternalButton />
      </Container>
    );
  }
};

export default App;
